import React from 'react';
import ClusterManagementView from './ClusterManagementView';

const ClusterManagementContainer = (props) => {
  return <ClusterManagementView {...props} />;
};

export default ClusterManagementContainer;
